"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSEResultState = void 0;
var SSEResultState;
(function (SSEResultState) {
    SSEResultState["Ack"] = "ack";
    SSEResultState["Bye"] = "bye";
    SSEResultState["Failure"] = "failure";
    SSEResultState["Features"] = "features";
    SSEResultState["Feature"] = "feature";
    SSEResultState["DeleteFeature"] = "delete_feature";
    SSEResultState["Config"] = "config";
    SSEResultState["Error"] = "error";
})(SSEResultState = exports.SSEResultState || (exports.SSEResultState = {}));
//# sourceMappingURL=sseresult-state.js.map